'use client';

import { useEffect, useState } from 'react';

export const useMediaQuery = (query: string, defaultMatches = false) => {
   const [matches, setMatches] = useState(defaultMatches);
   useEffect(() => {
      const mediaQuery = window.matchMedia(query);
      setMatches(mediaQuery.matches);
      const handler = (event: MediaQueryListEvent) => setMatches(event.matches);
      mediaQuery.addEventListener('change', handler);
      return () => mediaQuery.removeEventListener('change', handler);
   }, [query]);
   return matches;
};
